import { useState } from "react";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import QuoteModal from "../home/components/QuoteModal";
import ContactHero from "./components/ContactHero";
import ContactInfo from "./components/ContactInfo";
import ContactServices from "./components/ContactServices";

export default function ContactPage() {
  const [quoteOpen, setQuoteOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar onBookNow={() => setQuoteOpen(true)} />

      <main className="flex-1">
        <ContactHero />
        <ContactInfo />
        <ContactServices />

        {/* CTA Banner */}
        <section className="py-14 bg-cl-tint">
          <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
            <div className="bg-cl-lime rounded-3xl px-8 py-10 thick-border cartoon-shadow flex flex-col lg:flex-row items-center justify-between gap-6">
              <div>
                <h3 className="text-cl-dark font-black text-2xl mb-1">Need help or got a question?</h3>
                <p className="text-cl-dark/65 font-semibold text-sm">Message us on WhatsApp or call our team directly.</p>
              </div>
              <div className="flex flex-wrap items-center gap-4">
                <a
                  href="/contact"
                  className="flex items-center gap-2 bg-white text-cl-dark font-black px-7 py-3.5 rounded-full text-sm thick-border cartoon-shadow-sm whitespace-nowrap cursor-pointer hover:bg-cl-dark hover:text-white transition-colors"
                >
                  <i className="ri-customer-service-2-line"></i>
                  Contact us
                </a>
                <a
                  href="/book"
                  className="flex items-center gap-2 bg-cl-dark text-white font-black px-7 py-3.5 rounded-full text-sm cartoon-btn whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-price-tag-3-line"></i>
                  Get a quote
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <QuoteModal isOpen={quoteOpen} onClose={() => setQuoteOpen(false)} />
    </div>
  );
}
